import { useEffect, useState } from "react";

const ActiveProject = ({
    title,
    status,
    completion,
    isPositive,
}) => {
    const [progressWidth, setProgressWidth] = useState(0);

    useEffect(() => {
        // Trigger the animation after component mounts
        setTimeout(() => {
            setProgressWidth(Math.round(completion * 100));
        }, 100);
    }, [completion]);

    return (
        <div className="ActiveProject">
            <span className="title">{title}</span>
            <span
                className={`status ${
                    isPositive ? "good" : "bad"
                }`}
            >
                {status}
            </span>
            <div className="progressBar">
                <div
                    className="progress"
                    style={{
                        width: `${progressWidth}%`,
                        transition: "width 1s ease", // Ensure the animation is smooth
                    }}
                ></div>
            </div>
        </div>
    );
};

export default ActiveProject;
